import {formReducer, modelReducer, actions as formActions} from 'react-redux-form';
import {combineReducers} from 'redux';
import {entity as communicationPlans} from './communicationPlans';

const actionType = (action) => `schooladmin/communicationPlanEditor/${action}`;

const types = {
  LOAD: actionType('LOAD'),
  SAVE_BEGIN: actionType('SAVE_BEGIN'),
  SAVE_SUCCESS: actionType('SAVE_SUCCESS'),
  SAVE_ERROR: actionType('SAVE_ERROR')
};

// Reducers

const saving = (state = {}, action) => {
  switch (action.type) {
    case types.SAVE_BEGIN:
      return {...state, [action.id]: true};
    case types.SAVE_SUCCESS:
    case types.SAVE_ERROR:
      return {...state, [action.id]: false};
    default:
      return state;
  }
};

const errors = (state = {}, action) => {
  switch (action.type) {
    case types.LOAD:
    case types.SAVE_SUCCESS:
    case types.SAVE_BEGIN:
      return {};
    case types.SAVE_ERROR:
      return {...action.errors};
    default:
      return state;
  }
};

// Actions Creators

const load = (model) => (dispatch) => {
  dispatch({type: types.LOAD});
  dispatch(formActions.load('communicationPlanEditor.model', model));
};

const save = (model) => (dispatch) => {
  dispatch({type: types.SAVE_BEGIN, id: model.id});

  const savePromise = dispatch(communicationPlans.actions.save(model));

  savePromise.then(
    () => dispatch({type: types.SAVE_SUCCESS, id: model.id}),
    (response) => {
      const errors = response.communication_plan.errors;
      dispatch({type: types.SAVE_ERROR, errors: errors, id: model.id});
    })
  return savePromise;
};

// Exports

// State key for rule fields
export const ruleFieldsKey = 'ruleFields';
// Query params to select valid business rule fields from the fields API
export const ruleFieldsQuery = {
  leaf_only: true,
  grouping: {op: '!=', value: 'logic'},
  ctype: {op: '!=', value: ['TextField']},
  name: {op: '!=', value: ['complete_checklist_item_ids_years', 'incomplete_checklist_item_ids_years']}
};

const reducer = combineReducers({
  model: modelReducer('communicationPlanEditor.model'),
  form: formReducer('communicationPlanEditor.model'),
  saving,
  errors
});

export default reducer;

export const actions = {
  ...types,
  load,
  save
};
